/* unplugin-vue-components disabled */import { render } from "./Customer-Display.vue?vue&type=template&id=7739a282&scoped=true&ts=true"
import script from "./Customer-Display.vue?vue&type=script&lang=ts"
export * from "./Customer-Display.vue?vue&type=script&lang=ts"

import "./Customer-Display.vue?vue&type=style&index=0&id=7739a282&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7739a282"]])

export default __exports__